(() => {
  // Rails: arrows top right (tablet/desktop); a thin red progress bar under each rail (phones) that fills as you swipe.
  // The bar is driven by the browser's scroll timeline where supported; this script sets its starting fill and drives it elsewhere.
  const smooth = window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto';
  const cssTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
  const init = () => {
    document.querySelectorAll('[data-rail-scope]').forEach((scope) => {
      if (scope.dataset.railReady) return;
      scope.dataset.railReady = '1';
      const group = scope.querySelector('[data-rail-arrows]');
      const arrows = group ? group.querySelectorAll('[data-rail-dir]') : [];
      const rails = [...scope.querySelectorAll('.rail')];
      const bars = [...scope.querySelectorAll('[data-rail-progress]')];
      const barFor = (rail) => (bars.length > 1 ? bars.find((b) => b.dataset.for === rail.dataset.shelfPanel) : bars[0]);
      const activeRail = () => rails.find((r) => r.offsetParent !== null);
      const update = () => {
        rails.forEach((rail) => {
          const bar = barFor(rail);
          if (!bar || rail.offsetParent === null) return;
          const max = rail.scrollWidth - rail.clientWidth;
          bar.classList.toggle('is-static', max <= 4);
          const start = Math.min(1, rail.clientWidth / rail.scrollWidth);
          bar.style.setProperty('--start', start.toFixed(3));
          if (!cssTimeline && max > 4) {
            const pos = Math.min(1, Math.abs(rail.scrollLeft) / max);
            bar.style.setProperty('--p', (start + (1 - start) * pos).toFixed(3));
          }
        });
        const rail = activeRail();
        if (!rail || !group) return;
        const max = rail.scrollWidth - rail.clientWidth;
        group.hidden = max <= 4;
        arrows.forEach((b) => { b.disabled = b.dataset.railDir === '-1' ? Math.abs(rail.scrollLeft) <= 2 : Math.abs(rail.scrollLeft) >= max - 2; });
      };
      arrows.forEach((b) => b.addEventListener('click', () => {
        const rail = activeRail();
        if (!rail) return;
        const item = rail.querySelector('.rail-item');
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
        const perView = Math.max(1, Math.floor((rail.clientWidth + gap) / step));
        rail.scrollBy({ left: step * perView * Number(b.dataset.railDir) * (document.dir === 'rtl' ? -1 : 1), behavior: smooth });
      }));
      rails.forEach((r) => r.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true }));
      scope.querySelectorAll('input[type="radio"]').forEach((i) => i.addEventListener('change', () => requestAnimationFrame(update)));
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) rails.forEach((r) => new ResizeObserver(update).observe(r));
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
